import { render, staticRenderFns } from "./total.vue?vue&type=template&id=4854111f&scoped=true&"
import script from "./total.vue?vue&type=script&lang=js&"
export * from "./total.vue?vue&type=script&lang=js&"
import style0 from "./total.vue?vue&type=style&index=0&id=4854111f&prod&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../../../yiweb/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4854111f",
  null
  
)

export default component.exports